import { render } from "./ColumnLayout.vue?vue&type=template&id=2e0c2edf&scoped=true"
import script from "./ColumnLayout.vue?vue&type=script&lang=js"
export * from "./ColumnLayout.vue?vue&type=script&lang=js"

import "./ColumnLayout.vue?vue&type=style&index=0&id=2e0c2edf&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0c2edf"]])

export default __exports__